/**
 * Fallback expense category list. The authoritative, org-configurable list is
 * served by the API (`GET /v1/admin/expense-categories`); this is only used if
 * that request fails so dropdowns are never empty.
 */
export const DEFAULT_EXPENSE_CATEGORIES: string[] = [
  'Advertising',
  'Car and Truck Expenses',
  'Commissions and Fees',
  'Contract Labor',
  'Depreciation',
  'Employee Wages',
  'Insurance (Other than Health)',
  'Interest (Mortgage and Other)',
  'Legal and Professional Services',
  'Office Expenses',
  'Rent or Lease',
  'Repairs and Maintenance',
  'Supplies',
  'Taxes and Licenses',
  'Travel',
  'Meals',
  'Utilities',
  'Other Expenses'
];
